import type { SharePayload, ShareResponse, ShowPeerSessionRequestPayload } from '@sdk/payload.types'

/**
 * Dispatch iOS sharing dialog.
 *
 * @example
 * api.share({text: "example text", subject: "example subject"})
 */
export async function share(payload: SharePayload): Promise<ShareResponse> {
  return this.API.request('share', payload)
}

/**
 * Show peer session dialog with button coordinates, for local peer sharing feature.
 *
 * @example
 * api.showPeerSession({x: 100, y: 200})
 */
export async function showPeerSession(payload: ShowPeerSessionRequestPayload): Promise<void> {
  return this.API.request('show_peer_session', payload)
}
